import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import classList from '../../common/utils/classList';
import Link from '../../common/components/Link';

export default class PublicizeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.results = this.attrs.results;
    this.currentIndexWindow = app.data.currentIndexWindow;
  }

  className() {
    return 'NickameModal Modal--small dl-modal-small';
  }

  title() {
    return;
  }

  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }

    return (
      <div className={classList('Modal modal-dialog fade Modal-sign-container', this.className())}>
        <div className="Modal-publicize-content">{this.content()}</div>
      </div>
    );
  }

  content() {
    let image = this.currentIndexWindow.image;
    let localeImage = '';
    if (image) {
      // 将字符串映射转换为 JavaScript 对象
      const obj = JSON.parse(image);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      localeImage = map.get(app.data.locale);
    }
    let url = app.forum.attribute('baseUrl');
    return (
      <div className="Modal-img-box">
        <img src={localeImage}></img>
        <div className="Form-group">
          <Link href={
              this.currentIndexWindow.img_link
                ? this.currentIndexWindow.img_link && this.currentIndexWindow.img_link.includes('http')
                  ? this.currentIndexWindow.img_link
                  : url + this.currentIndexWindow.img_link
                : '#'
            } className="Button digimon" onclick={() => app.modal.close()}>
            {app.translator.trans('dl_index_window.forum.go_now')}
          </Link>
        </div>
      </div>
    );
  }
}
